// src/utils/upgradeHelper.ts
import {toggleErrorDialog} from '../redux/config'
import {getUpgradePrice, trackMemberUpgrade} from '../redux/members'

export const handleUpgrade =
  (dispatch: any, auth: any, member: any, origin: string) => async () => {
    // Check the subscription type from the first group account, if available
    const groupSubscriptionType =
      member?.groupAccounts && member.groupAccounts.length > 0
        ? member.groupAccounts[0].subscriptionType
        : undefined
    // Check if the user part of a group account
    if (member?.groupAccounts && member.groupAccounts.length > 0) {
      // Check if user is an admin
      if (member.groupAccounts[0].admin === true) {
        if (groupSubscriptionType === 'self-serve') {
          // If admin and self-serve, open the firm checkout cart
          window.location.href =
            process.env.REACT_APP_12_MONTH_EXPERT_URL_FIRM ||
            'https://www.blackspectacles.com/firm-pricing'
        } else {
          // If admin and custom plan, show account management message.
          await dispatch(
            toggleErrorDialog({
              opened: true,
              title: 'Upgrade to Expert',
              error:
                'Please contact accountmanagement@blackspectacles.com to upgrade the terms of your existing contract',
            }),
          )
          return
        }
      } else {
        // Not an admin: ask the user to contact their firm admin.
        await dispatch(
          toggleErrorDialog({
            opened: true,
            title: 'Upgrade to Expert',
            error:
              'Please ask your firm admin to upgrade your subscription to gain access to this material.',
          }),
        )
      }
    } else {
      // Not part of a group account; redirect to the cart.
      const {type, payload} = await dispatch(getUpgradePrice({auth}))
      if (type === getUpgradePrice.fulfilled.type) {
        await dispatch(trackMemberUpgrade({auth, origin}))
        const priceId = payload?.priceId
        window.location.href =
          String(priceId).length > 0
            ? 'https://checkout.blackspectacles.com/' + String(priceId)
            : '#'
      }
    }
  }
